const buttonEquipStatusInput = {
  text: '	To send'
};

export default buttonEquipStatusInput;
